/** Tab routing constants — keep free of tab component imports for safe eager use in redirects. */

export const DEFAULT_SETTINGS_TAB = 'overview';

export const LEGACY_TAB_MAPPING: Record<string, string> = {
  info: 'overview',
  mfa: 'mfa',
  embed: 'embed',
  ai: 'ai',
  'ai-integrations': 'ai',
  analytics: 'analytics',
  'analytics-integrations': 'analytics',
  'intelligence-widget': 'embed',
  'platform-security': 'security',
  'platform-notifications': 'system-notifications',
  'ip-whitelist': 'ip-whitelist',
  'notification-history': 'notification-history',
  'system-notifications': 'system-notifications',
  'api-keys': 'api-keys',
  'login-history': 'login-history',
  billing: 'billing',
};
